<template>
<div class="value-show">
  <router-link :to="{ path: getLeadPathWithQueries(params.project_id, item.id) }">
    <div v-if="item.firstname || item.lastname">
      <span class="value-show--firstname">{{item.firstname}}</span>
      <span class="value-show--lastname">{{item.lastname}}</span><br>
    </div>
    <div v-else>
      <span class="value-show--firstname">{{item.email}}</span>
    </div>
  </router-link>
</div>
</template>
<script>
import GetUrlQueries from '@/classes/GetUrlQueries'

export default {
  props: ['item', 'column', 'structure', 'model', 'params'],
  methods: {
    getLeadPathWithQueries(project_id, lead_id) {
      let url_queries = GetUrlQueries.urlQueries(this.$route.query)
      return `/${this.$t("routes.project")}/${project_id}/${this.$t("routes.project_leads")}/${lead_id}/edit${url_queries}`
    }
  },

  computed: {
    companyFunction(){
      if(_.get(this.column, 'lead_mask.company_function.params.no_i18n')){
        let allowed_values = _.get(this.column,'lead_mask.company_function.allowed_values')
        if(allowed_values){
          let index = _.findIndex(allowed_values, { 'value': this.item.company_function })
          if(allowed_values[index]){
            return allowed_values[index].name
          }else{
            return ''
          }
        }else{
          return ''
        }
      }else{
        if (this.$t('models.select_company_function.' + this.item.company_function).includes("models.select_company_function"))
          return this.item.company_function
        else
          return this.$t('models.select_company_function.' + this.item.company_function)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// CollectionValueLeadName.vue?2049e8d5